import { render, staticRenderFns } from "./RiskAssessmentCreation.vue?vue&type=template&id=7c4270c8&scoped=true&"
import script from "./RiskAssessmentCreation.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4270c8",
  null
  
)

export default component.exports